import { Flex } from "@chakra-ui/layout";
import { useDisclosure } from "@chakra-ui/react";
import { useDeleteVeiculo } from "core/features/veiculo/hooks/useDeleteVeiculo";
import { useListarVeiculos } from "core/features/veiculo/hooks/useListarVeiculos";
import {
  showConfirm2,
  showErrorAxios,
  showSuccess,
  useLoading,
} from "infra/helpers/alerta";
import useFiltro from "infra/helpers/useFiltro";
import { useState } from "react";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import NewTable from "ui/components/NewTable";
import ModalCadastroVeiculo from "./components/ModalCadastroVeiculo";
import useTabelaVeiculosColumns from "./hooks/useTabelaVeiculosColumns";

function TabVeiculos({ unidadeId }: { unidadeId: string }) {
  const { isOpen: isOpenModal, onToggle: onToggleModal } = useDisclosure();
  const [idEdit, setIdEdit] = useState<string | undefined>();
  const columns = useTabelaVeiculosColumns();
  const { filtro, onChangeFiltro } = useFiltro();
  const { data, isLoading, isFetching, refetch } = useListarVeiculos({
    ...filtro,
    unidadeId,
  });

  const { isLoading: isLoadingDelete, mutate: handleDelete } =
    useDeleteVeiculo();

  useLoading(isLoadingDelete);

  return (
    <>
      {isOpenModal ? (
        <ModalCadastroVeiculo
          onSaved={() => {
            refetch();
          }}
          id={idEdit}
          isOpen={isOpenModal}
          onClose={() => {
            setIdEdit(undefined);
            onToggleModal();
          }}
          unidadeId={unidadeId}
        />
      ) : null}

      <NewTable
        title={() => (
          <Flex>
            <Flex>
              <PrimaryButton
                onClick={(ev) => {
                  ev.stopPropagation();
                  onToggleModal();
                }}
              >
                Adicionar
              </PrimaryButton>
            </Flex>
          </Flex>
        )}
        actions={[
          {
            title: "Editar",
            onClick: (v) => {
              setIdEdit(v.id);
              onToggleModal();
            },
          },
          {
            title: "Excluir",
            onClick: (v) => {
              showConfirm2({
                onOk: () => {
                  handleDelete(v.id, {
                    onSuccess: () => {
                      setTimeout(() => {
                        showSuccess().then(() => {
                          if (filtro.page! > 1) {
                            onChangeFiltro("page", 1);
                          } else {
                            refetch();
                          }
                        });
                      }, 250);
                    },
                    onError: (err) => {
                      setTimeout(() => {
                        showErrorAxios(err);
                      }, 250);
                    },
                  });
                },
              });
            },
          },
        ]}
        loading={isLoading || isFetching}
        dataSource={data?.items ?? []}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          onChangePage: (p) => onChangeFiltro("page", p),
        }}
        columns={columns}
      />
    </>
  );
}

export default TabVeiculos;
